module.exports = __webpack_public_path__ + "src/assets/images/product-icons/icon-wind.svg?da3325ca5272452e2c8fb3226d7b9512";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product-icons/icon-wind.svg
// module id = 1055
// module chunks = 1